import { Dispatch, SetStateAction } from 'react';

interface Parameter {
  name: string;
  value: any;
}

interface Row {
  parameters: Parameter[];
  [key: string]: any;
}

export const useNestedParameterUpdate = (setCurrentData: Dispatch<SetStateAction<Row[]>>) => {
  const updateNestedParameter = (rowIndex: number, paramName: string, value: any) => {
    setCurrentData((oldData) =>
      oldData.map((row, index) => {
        if (index === rowIndex) {
          const updatedParameters = row.parameters.map((param) => {
            if (param.name === paramName) {
              return { ...param, value };
            }
            return param;
          });

          return {
            ...row,
            parameters: updatedParameters,
          };
        }
        return row;
      })
    );
  };

  return updateNestedParameter;
};

export type UpdateNestedParameterFn = (rowIndex: number, paramName: string, value: any) => void;
